














import Vue from 'vue'
import { closest, offset } from '@/utils/domUtils'

type Data = {
  isOpen: boolean;
  startStyle: { [key: string]: string };
  bodyStyle: {
    display: string;
    marginLeft: string;
  };
};

// jQuery相当の関数 他でも使用する場合は、domUtilsに定義する
function outerWidth (node: HTMLElement, margin = false): number {
  const offsetWidth = node.offsetWidth
  if (!margin) {
    return offsetWidth
  }
  const marginLeft = node.style.marginLeft ? parseInt(node.style.marginLeft) : 0
  const marginRight = node.style.marginRight ? parseInt(node.style.marginRight) : 0
  return offsetWidth + marginLeft + marginRight
}

export default Vue.extend({
  name: 'HelpBalloon',
  props: {
    helpId: {
      type: String,
      required: true
    }
  },
  data (): Data {
    return {
      isOpen: false,
      startStyle: {},
      bodyStyle: {
        display: 'none',
        marginLeft: '0px'
      }
    }
  },
  mounted () {
    document.body.addEventListener('click', this.onDocumentClick)
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    document.body.removeEventListener('click', this.onDocumentClick)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onDocumentClick (e: MouseEvent): void {
      if (!closest(e.target, '#' + this.helpId)) {
        this.close()
      }
    },
    toggle (e: MouseEvent): void {
      e.preventDefault()
      this.bodyStyle.display = this.bodyStyle.display === 'none' ? 'block' : 'none'
      if (this.bodyStyle.display === 'block') {
        this.$nextTick(() => this.adjust())
      }
    },
    close (): void {
      this.bodyStyle.display = 'none'
    },
    /**
     * 表示位置調整
     */
    adjust (): void {
      this.adjustBody()
    },
    adjustBody (): void {
      const labelOffset = offset(this.$refs.label as HTMLElement)
      this.bodyStyle.marginLeft = '0px'
      this.$nextTick(() => {
        const bodyOffset = offset(this.$refs.body as HTMLElement)

        if (labelOffset && bodyOffset) {
          const labelCenter = labelOffset.left - 25 + ((outerWidth(this.$refs.label as HTMLElement, true) / 2))
          const bodyCenter = bodyOffset.left + (outerWidth(this.$refs.body as HTMLElement) / 2)

          let pos = labelCenter - bodyCenter
          if (bodyOffset.left + pos < 15) {
            pos -= (bodyOffset.left + pos - 15)
          }
          this.bodyStyle.marginLeft = pos + 'px'
        }
        this.$nextTick(() => this.adjustStart())
      })
    },
    adjustStart (): void {
      const labelOffset = offset(this.$refs.label as HTMLElement)
      const bodyOffset = offset(this.$refs.body as HTMLElement)

      if (labelOffset && bodyOffset) {
        const labelCenter = labelOffset.left - 25 + ((outerWidth(this.$refs.label as HTMLElement, true) / 2))
        const pos = Math.max(0, labelCenter - bodyOffset.left - (outerWidth(this.$refs.start as HTMLElement) / 2))
        this.startStyle.marginLeft = pos + 'px'
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onResize (this: any): void {
      if (this.bodyStyle.display === 'block') {
        this.adjust()
      }
    }
  }
})
